export const DEFAULT_CREATED_RANGE = 'last_7_days';
export const ALL_CREATED_RANGE = 'all';

export const CREATED_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_7_days', label: 'Last 7 Days' },
  { value: 'last_30_days', label: 'Last 30 Days' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'last_6_months', label: 'Last 6 Months' },
  { value: 'last_year', label: 'Last Year' },
];

const startOfLocalDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

const addLocalDays = (d, n) => {
  const next = startOfLocalDay(d);
  next.setDate(next.getDate() + n);
  return next;
};

const parseLocalDate = (ymd) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const tenantOptionLabel = (tenant) => {
  if (!tenant) return '';
  if (typeof tenant === 'string') return tenant;
  const code = tenant.code || '';
  const location = (tenant.location || '').trim();
  if (location && code) return `${location} (${code})`;
  return location || code;
};

/** Location name for a tenant code, falling back to the code when unknown. */
export const tenantDisplayName = (code, tenants = []) => {
  if (!code) return '';
  const match = (tenants || []).find((tenant) =>
    typeof tenant === 'string' ? tenant === code : tenant?.code === code
  );
  const location =
    match && typeof match === 'object' ? (match.location || '').trim() : '';
  return location || code;
};

export const formatLocalDate = (d) => {
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** Dropdown value. A picked day shows "all"; a missing range is Last 7 Days. */
export const createdRangeValue = (rangeParam, on) => {
  if (on) return ALL_CREATED_RANGE;
  if (!rangeParam) return DEFAULT_CREATED_RANGE;
  return rangeParam;
};

/** Preset passed to createdWindow. "all" and a picked day apply no preset. */
export const createdRangeQuery = (rangeParam, on) => {
  const value = createdRangeValue(rangeParam, on);
  if (on || value === ALL_CREATED_RANGE) return '';
  return value;
};

/** Inclusive local-day start and exclusive end, as ISO strings for the list API. */
export const createdWindow = ({ range = '', on = '', now = new Date() } = {}) => {
  const onDay = parseLocalDate(on);
  if (onDay) {
    return {
      created_after: onDay.toISOString(),
      created_before: addLocalDays(onDay, 1).toISOString(),
    };
  }
  if (!range) return {};
  const today = startOfLocalDay(now);
  const tomorrow = addLocalDays(today, 1);
  if (range === 'yesterday') {
    return {
      created_after: addLocalDays(today, -1).toISOString(),
      created_before: today.toISOString(),
    };
  }
  let start = today;
  if (range === 'today') {
    start = today;
  } else if (range === 'last_7_days') {
    start = addLocalDays(today, -6);
  } else if (range === 'last_30_days') {
    start = addLocalDays(today, -29);
  } else if (range === 'last_3_months') {
    start = new Date(today);
    start.setMonth(start.getMonth() - 3);
  } else if (range === 'last_6_months') {
    start = new Date(today);
    start.setMonth(start.getMonth() - 6);
  } else if (range === 'last_year') {
    start = new Date(today);
    start.setFullYear(start.getFullYear() - 1);
  } else {
    return {};
  }
  return {
    created_after: start.toISOString(),
    created_before: tomorrow.toISOString(),
  };
};

export const parseLocalDateParam = parseLocalDate;
